import TypeIt from "typeit";
import { tns } from "tiny-slider/src/tiny-slider.module";
import PerfectScrollbar from 'perfect-scrollbar';

if(document.querySelector(".portfolio-list")){
  
  const ps = new PerfectScrollbar('.portfolio-list', {
    wheelSpeed: 2,
    wheelPropagation: true,
    minScrollbarLength: 20,
    suppressScrollX: true
  });
  
}

document.addEventListener('DOMContentLoaded', function () {

  // Get all "navbar-burger" elements
  var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach(function ($el) {
      $el.addEventListener('click', function () {

        // Get the target from the "data-target" attribute
        var target = $el.dataset.target;
        var $target = document.getElementById("navMenu");

        // Toggle the class on both the "navbar-burger" and the "navbar-menu"
        $el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

});


var wordListIndex = 0;

var isInViewport = function (elem) {
  if(elem != undefined){
    var bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
};

var stringlist;

if(document.querySelectorAll('#typewriter.en').length){
  stringlist = [
    'strategists.',
    'designers.',
    'creatives.',
    'ninjas.',
    'thinkers.',
    'doers.'
  ];
}else{
  stringlist = [
    'creadores.',
    'diseñadores.',
    'obsesivos.',
    'ninjas.'
  ]
}

var lolwat = new TypeIt('#typewriter', {
  strings: stringlist,
  autoStart: true,
  breakLines: false,
  speed: 200,
  loop: true,
  nextStringDelay: 3000
});

var mainLazyLoad = new LazyLoad();

$(function(){
  
  $("input#form1_telefono").keydown(function (e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
           // Allow: Ctrl/cmd+A
          (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
           // Allow: Ctrl/cmd+C
          (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
           // Allow: Ctrl/cmd+X
          (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
           // Allow: home, end, left, right
          (e.keyCode >= 35 && e.keyCode <= 39)) {
               // let it happen, don't do anything
               return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
      }
  });
  
  
  $('.player').YTPlayer();
  
  var slider = tns({
    container: '.slideshow-servicios',
    items: 1,
    nav: false,
    autoplay: true,
    autoplayButtonOutput: false,
    controls: false,
    loop: true
  });
  
  var clients = tns({
    container: '.home-client-list',
    items: 2,
    nav: false,
    autoplay: true,
    autoplayButtonOutput: false,
    controls: false,
    loop: false,
    responsive: {
      1024: {
        items: 4
      },
      1200: {
        items: 6
      }
    }
  });
  
  $('#mobile-category-selector').change(function(){
    var url = $(this).val();
    if (url) { 
      window.location = url;
    }
    return false;
  });
  
  $.validate({
    form : '#form1_contacto'
  });
  
  $('.hero-content .inner-content').addClass('in');
  
  
  //portfafolio ajax loading
  $('body.portafolio a.portfolio-item').click(function(event){
    event.preventDefault();
    $('#display-work').addClass('show');
    
    $.get( $(this).data('target') , function( data ) {
      $('#display-work .work-container').html( data );
      
      setTimeout(function(){
        
        const projectscroll = new PerfectScrollbar('.portfolio-detail-content', {
          wheelSpeed: 2,
          wheelPropagation: true,
          minScrollbarLength: 20,
          suppressScrollX: true
        });
        
        $('.portfolio-close').click(function(event){
          event.preventDefault();
          $('#display-work').removeClass('show');
          $('#display-work .work-container').html(' ');
          history.pushState({}, "Metamorfo | Portafolio", "/portafolio/");
        });
        
        var lazyLoad = new LazyLoad({
          container: document.querySelector('.portfolio-detail-content')
        });
        
      }, 100);
      
      // console.log($(event.currentTarget).find('.project-info h2').text());
      // console.log($(event.currentTarget).attr('href'));
      history.pushState({}, "Metamorfo | "+$(event.currentTarget).find('.project-info h2').text(), $(event.currentTarget).attr('href'));
      
    });
  });
  
  $('#project-id').each(function(){
    $('#display-work').addClass('show');
    
    $.get( "/portafolio/index.php?pid="+$('#project-id').val() , function( data ) {
      $('#display-work .work-container').html( data );
      
      setTimeout(function(){
        
        const projectscroll = new PerfectScrollbar('.portfolio-detail-content', {
          wheelSpeed: 2,
          wheelPropagation: true,
          minScrollbarLength: 20,
          suppressScrollX: true
        });
        
        $('.portfolio-close, #modal-overlay').click(function(event){
          event.preventDefault();
          $('#display-work').removeClass('show');
          $('#display-work .work-container').html(' ');
          history.pushState({}, "Metamorfo | Portafolio", "/portafolio/");
        });
        
        var lazyLoad = new LazyLoad({
          container: document.querySelector('.portfolio-detail-content')
        });
        
      }, 100);
      
    });
  });
  
});

function animateWordList(){
  wordListIndex++;
  $('.word-list li').eq(wordListIndex%$('.word-list li').length-1).find('span').addClass('hover').delay(1000).queue(function () {
    $('.word-list li').eq(wordListIndex%$('.word-list li').length-1).find('span').removeClass('hover');
    $(this).dequeue();
    animateWordList();
  })
}

function onScroll(){
  var navElement = document.getElementById("mainNav");
  var navBarTrigger = 50;
  
  if(typeof isHome !== 'undefined'){
    var hero = document.querySelector('.super-hero');
    var heroBounds = hero.getBoundingClientRect();
    
    if(heroBounds.bottom < 50){
      navElement.classList.add("nav-fixed");
    }else{
      navElement.classList.remove("nav-fixed");
    }
  }else{
    if (document.body.scrollTop > navBarTrigger || document.documentElement.scrollTop > navBarTrigger){
      navElement.classList.add("nav-fixed");
    }else{
      navElement.classList.remove("nav-fixed");
    }
  }
  
  
  var elmWordList = document.querySelector('.word-list');
  if(isInViewport(elmWordList) && !wordListIndex){
    animateWordList();
  }
}

onScroll();
window.onscroll = onScroll;

if(document.getElementById("modal-overlay")){
  document.getElementById("modal-overlay").onwheel = function(event) {
    // console.log('onwheel');
    // console.log(event);
    // 
    var projectContent = document.querySelector(".portfolio-detail-content");
    // console.log(projectContent);
    
    if(projectContent){
      projectContent.scrollBy(0, event.deltaY);
    }
  };
}

if(document.querySelector("body.portafolio")){
  document.getElementById("main").onwheel = function(event) {
    var portfolioContent = document.querySelector(".portfolio-list");
    if(portfolioContent){
      portfolioContent.scrollBy(0, event.deltaY);
    }
  }
}



// WEBPACK FOOTER //
// ./src/main.js